<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input size="small" v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="" label="订单号">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="order-code">
                <div>订单ID：{{ scope.row.orderId }}</div>
                <div class="c_main">{{ scope.row.orderNo }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="技师信息" min-width="100">
            <template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.waiter"> 
                <div style="display:flex">
                  <img class="img" v-img-url="scope.row.waiter.avatarUrl" alt="" />
                  <div class="name gray3 product-name">
                      <div>{{ scope.row.waiter.username }}(ID:{{ scope.row.waiter.waiter_user_id }})</div>
                      <div>{{ scope.row.waiter.mobile }}</div>
                  </div>
                </div>               
            </template>
          </el-table-column>   
          <el-table-column prop="pay_type.text" label="内容">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">堵车</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="图片内容">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                <div class="pic"><img v-img-url="item.image.filePath" alt="" /></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="下单时间">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button @click="addClick(scope.row)" type="info" size="small" v-auth="'/order/order/detail'">详情</el-button>
              <!-- <el-button @click="cancelClick(scope.row)" type="text" size="small" v-if="scope.row.pay_status.value==20">取消订单</el-button> -->
            </template>
  
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js';
import qs from 'qs';
export default {
  data() {
    return {
      /*切换菜单*/
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search:'',
        orderNo: '',
        style_id: '',
        createTime: ''
      },
      /*时间*/
      createTime: ''
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
	  console.log(self.activeName)
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      OrderApi.orderlist(Params, true)
        .then(res => {
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.orderId;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          orderId: params
        }
      });
    },   
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    }
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>
<style lang="scss" scoped>
.img{
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/platerefund/index.vue